export default __webpack_public_path__ + "static/media/type2_4in.ba373425.svg";